import { jsx as _jsx } from "react/jsx-runtime";
import { useDevices, useMediaPermissions, useSelectMediaDeviceCallback, useSelectedDevices, } from '../utils/media';
import { ButtonList, ButtonListItem } from './ButtonList';
import { DeviceBlockedPlate } from './DeviceBlockedPlate';
import { BlankIcon, CheckMarkIcon } from './Icon';
function DeviceList({ devices, selectedDevice, onSelectDevice, }) {
    return (_jsx(ButtonList, { children: devices.map((device, index) => (_jsx("li", { children: _jsx(ButtonListItem, { type: "button", onClick: () => {
                    onSelectDevice?.(device);
                }, prependComponent: selectedDevice?.deviceId === device.deviceId ? (_jsx(CheckMarkIcon, {})) : (_jsx(BlankIcon, { size: "1.25rem" })), children: device.label }) }, device.deviceId || index))) }));
}
export function AudioDeviceList({ onDeviceSelect }) {
    const { audio: devices } = useDevices();
    const { audio: currentDevice } = useSelectedDevices();
    const setSelectedDevice = useSelectMediaDeviceCallback();
    const { audio: canAccessMicrophone } = useMediaPermissions();
    if (!canAccessMicrophone || !devices.length) {
        return _jsx(DeviceBlockedPlate, { kind: "audio" });
    }
    return (_jsx(DeviceList, { devices: devices, selectedDevice: currentDevice, onSelectDevice: (device) => {
            setSelectedDevice('audio', device.deviceId);
            onDeviceSelect?.(device);
        } }));
}
export function VideoDeviceList({ onDeviceSelect }) {
    const { video: devices } = useDevices();
    const { video: currentDevice } = useSelectedDevices();
    const setSelectedDevice = useSelectMediaDeviceCallback();
    const { video: canAccessCamera } = useMediaPermissions();
    if (!canAccessCamera || !devices.length) {
        return _jsx(DeviceBlockedPlate, { kind: "video" });
    }
    return (_jsx(DeviceList, { devices: devices, selectedDevice: currentDevice, onSelectDevice: (device) => {
            setSelectedDevice('video', device.deviceId);
            onDeviceSelect?.(device);
        } }));
}
